import { ReactComponent as Logo } from 'asserts/logo/exbody_footer.svg';
import styled from 'styled-components';
import Adress from './Adress';

const Footer = () => {
  return (
    <>
      <LogoWrapper>
        <Logo />
      </LogoWrapper>
      <Adress />
    </>
  );
};

export default Footer;

const LogoWrapper = styled.h2`
  padding-bottom: 8px;
`;
